import { render, staticRenderFns } from "./fees-costs.vue?vue&type=template&id=4ef781bc"
import script from "./fees-costs.vue?vue&type=script&lang=js"
export * from "./fees-costs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports